const dictinaryMngt = {
    namespaced: true,
    state : {
        dictionaryCd : '',
        dictionaryNm : '',
        dictionaryHrbSeq : '',
        chkInfo : '',
        status : ''
    },
    getters: {
        getDictionaryCd(state) {
            return state.dictionaryCd
        },
        getDictionaryNm (state) {
            return state.dictionaryNm
        },
        getDictionaryHrbSeq (state) {
            return state.dictionaryHrbSeq
        },
        getChkInfo (state) {
            return state.chkInfo
        },
        getStatus (state) {
            return state.status
        },
    },
    mutations: {
        setDictionaryCd (state, payload) {
            state.dictionaryCd = payload
        },
        setDictionaryNm (state, payload) {
            state.dictionaryNm = payload
        },
        setDictionaryHrbSeq (state, payload) {
            state.dictionaryHrbSeq = payload
        },
        setChkInfo (state, payload) {
            state.chkInfo = payload
        },
        setStatus (state, payload) {
            state.status = payload
        },

    },
    actions: {
        setDictionaryCd ({commit}, payload) {
            commit('setDictionaryCd', payload)
        },
        setDictionaryNm ({commit}, payload) {
            commit('setDictionaryNm', payload)
        },
        setDictionaryHrbSeq ({commit}, payload) {
            commit('setDictionaryHrbSeq', payload)
        },
        setChkInfo ({commit}, payload) {
            commit('setChkInfo', payload)
        },
        setStatus ({commit}, payload) {
            commit('setStatus', payload)
        },
        setMedicineMngtinit ({commit}) {
            commit('setMedicineCd','');
            commit('setMedicineNm','');
            commit('setMedHrbDtlSeq','');
            commit('setChkInfo','');
            commit('setStatus','');
        },
    }
}


export default dictinaryMngt